<div class="content-header">
    <h2>Manuales y Tutoriales</h2>
</div>


<div class="row g-4 align-items-center">
    <div class="row g-4">
        <!-- Manuales -->
        <div class="col-lg-6 aos-init aos-animate" data-aos="fade-up">
            <div class="container-fluid p-0">
                <h3 class="h5 fw-bold mb-2">Manuales</h3>
                <p class="small text-muted mb-4">Consulta y descarga las guías y documentación técnica de la Plataforma
                    de Interconexión.</p>

                <div class="row g-4">
                    <div class="col-12">
                        <div class="doc-card">

                            <div class="flex-grow-1">
                                <div class="fw-semibold">Guía de Usuario Plataforma de Interconexión con Autoridades
                                </div>
                            </div>
                            <a class="btn btn-sm btn-dark rounded-pill manual-download-btn"
                                href="https://www.oaj.gob.mx/interconexion/assets/docs/pdf/Gu%C3%ADa%20de%20usuario%20Plataforma%20Interconexi%C3%B3n%20con%20Autoridades%201.pdf"
                                target="_blank"><i class="far fa-file-pdf"></i> Descargar</a>
                        </div>
                    </div><!--BTN ROW-->
                    <div class="col-12">
                        <div class="doc-card">

                            <div class="flex-grow-1">
                                <div class="fw-semibold">¿Cómo ingresar a la Plataforma de Interconexión con
                                    Autoridades? </div>
                            </div>
                            <!-- <a class="btn btn-sm btn-dark rounded-pill manual-download-btn"
                                href="https://www.oaj.gob.mx/interconexion/assets/docs/pdf/1.%20Como%20ingresar%20a%20la%20Plataforma%20de%20Interconexi%C3%B3n%20con%20Autoridades.pdf"
                                target="_blank">Descargar</a> -->
                                <a class="btn btn-sm btn-dark rounded-pill manual-download-btn"
                                tabindex="0"
                                (click)="openImageModal('https://www.oaj.gob.mx/interconexion/assets/img/01_Plataforma_Interconexion_Autoridades.png', '¿Cómo ingresar a la Plataforma de Interconexión con Autoridades?', 'Ingresar_Plataforma.png')"
                                 (keypress.enter)="openImageModal('https://www.oaj.gob.mx/interconexion/assets/img/01_Plataforma_Interconexion_Autoridades.png', '¿Cómo ingresar a la Plataforma de Interconexión con Autoridades?', 'Ingresar_Plataforma.png')"
                                style="cursor: pointer;">
                                <i class="fas fa-image"></i> Ver
                            </a>
                        </div>
                    </div><!--BTN ROW-->
                    <div class="col-12">
                        <div class="doc-card">

                            <div class="flex-grow-1">
                                <div class="fw-semibold">¿Cómo notificarme a través de la Plataforma de Interconexión
                                    con Autoridades? </div>
                            </div>
                          <!--   <a class="btn btn-sm btn-dark rounded-pill manual-download-btn"
                                href="https://www.oaj.gob.mx/interconexion/assets/docs/pdf/2.%20Como%20notificarme%20a%20trav%C3%A9s%20de%20la%20Plataforma%20de%20Interconexi%C3%B3n%20con%20Autoridades.pdf"
                                target="_blank">Descargar</a> -->
                                <a class="btn btn-sm btn-dark rounded-pill manual-download-btn"
                                tabindex="0"
                                (click)="openImageModal('https://www.oaj.gob.mx/interconexion/assets/img/02_Notificarme_Plataforma.png', '¿Cómo notificarme a través de la Plataforma de Interconexión con Autoridades?', 'Notificarme_Plataforma.png')"
                                (keypress.enter)="openImageModal('https://www.oaj.gob.mx/interconexion/assets/img/02_Notificarme_Plataforma.png', '¿Cómo notificarme a través de la Plataforma de Interconexión con Autoridades?', 'Notificarme_Plataforma.png')"   
                                style="cursor: pointer;">
                                <i class="fas fa-image"></i> Ver
                            </a>
                        </div>
                    </div><!--BTN ROW-->
                    <div class="col-12">
                        <div class="doc-card">

                            <div class="flex-grow-1">
                                <div class="fw-semibold">¿Cómo consultar los archivos de las determinaciones y las
                                    constancias de notificación? </div>
                            </div>
                          <!--   <a class="btn btn-sm btn-dark rounded-pill manual-download-btn"
                                href="https://www.oaj.gob.mx/interconexion/assets/docs/pdf/3.%20C%C3%B3mo%20consultar%20los%20archivos%20de%20las%20determinaciones%20y%20las%20constancias%20de%20notificaci%C3%B3n.pdf"
                                target="_blank">Descargar</a> -->
                                 <a class="btn btn-sm btn-dark rounded-pill manual-download-btn"
                                tabindex="0"
                                (click)="openImageModal('https://www.oaj.gob.mx/interconexion/assets/img/03_Consultar_Archivos_Determinaciones.png', '¿Cómo consultar los archivos de las determinaciones y las constancias de notificación?', 'Consultar_Archivos_Determinaciones.png')"
                                (keypress.enter)="openImageModal('https://www.oaj.gob.mx/interconexion/assets/img/03_Consultar_Archivos_Determinaciones.png', '¿Cómo consultar los archivos de las determinaciones y las constancias de notificación?', 'Consultar_Archivos_Determinaciones.png')"   
                                style="cursor: pointer;">
                                <i class="fas fa-image"></i> Ver
                            </a>
                        </div>
                    </div><!--BTN ROW-->
                    <div class="col-12">
                        <div class="doc-card">

                            <div class="flex-grow-1">
                                <div class="fw-semibold">¿Cómo consultar el expediente electrónico? </div>
                            </div>
                           <!--  <a class="btn btn-sm btn-dark rounded-pill manual-download-btn"
                                href="https://www.oaj.gob.mx/interconexion/assets/docs/pdf/4.%20C%C3%B3mo%20consultar%20el%20expediente%20electr%C3%B3nico.pdf"
                                target="_blank">Descargar</a> -->
                                <a class="btn btn-sm btn-dark rounded-pill manual-download-btn"
                                tabindex="0"
                                (click)="openImageModal('https://www.oaj.gob.mx/interconexion/assets/img/04_Consultar_Expediente_Electronico.png', '¿Cómo consultar el expediente electrónico?', 'Consultar_Expediente_Electronico.png')"
                                (keypress.enter)="openImageModal('https://www.oaj.gob.mx/interconexion/assets/img/04_Consultar_Expediente_Electronico.png', '¿Cómo consultar el expediente electrónico?', 'Consultar_Expediente_Electronico.png')"   
                                style="cursor: pointer;">
                                <i class="fas fa-image"></i> Ver
                            </a>
                        </div>
                    </div><!--BTN ROW-->
                    <div class="col-12">
                        <div class="doc-card">
                            <div class="flex-grow-1">
                                <div class="fw-semibold">¿Cómo enviar una promoción electrónica? </div>
                            </div>
                          <!--   <a class="btn btn-sm btn-dark rounded-pill manual-download-btn"
                                href="https://www.oaj.gob.mx/interconexion/assets/docs/pdf/5.%20C%C3%B3mo%20enviar%20una%20promoci%C3%B3n%20electr%C3%B3nica.pdf"
                                target="_blank">Descargar</a> -->
                                <a class="btn btn-sm btn-dark rounded-pill manual-download-btn"
                                tabindex="0"
                                (click)="openImageModal('https://www.oaj.gob.mx/interconexion/assets/img/05_Enviar_Promocion_Electronica.png', '¿Cómo enviar una promoción electrónica?', 'Enviar_Promocion_Electronica.png')"
                                (keypress.enter)="openImageModal('https://www.oaj.gob.mx/interconexion/assets/img/05_Enviar_Promocion_Electronica.png', '¿Cómo enviar una promoción electrónica?', 'Enviar_Promocion_Electronica.png')"   
                                style="cursor: pointer;">
                                <i class="fas fa-image"></i> Ver
                            </a>
                        </div>
                    </div><!--BTN ROW-->
                    <div class="col-12">
                        <div class="doc-card">
                            <div class="flex-grow-1">
                                <div class="fw-semibold">¿Cómo enviar una demanda o escrito inicial de manera
                                    electrónica? </div>
                            </div>
                         <!--    <a class="btn btn-sm btn-dark rounded-pill manual-download-btn"
                                href="https://www.oaj.gob.mx/interconexion/assets/docs/pdf/6.%20C%C3%B3mo%20enviar%20una%20demanda%20o%20escrito%20inicial%20de%20manera%20electr%C3%B3nica.pdf"
                                target="_blank">Descargar</a> -->
                                 <a class="btn btn-sm btn-dark rounded-pill manual-download-btn"
                                tabindex="0"
                                (click)="openImageModal('https://www.oaj.gob.mx/interconexion/assets/img/06_Enviar_Demanda_Escrito_Inicial.png', '¿Cómo enviar una demanda o escrito inicial de manera electrónica?', 'Enviar_Demanda_Escrito_Inicial.png')"
                                (keypress.enter)="openImageModal('https://www.oaj.gob.mx/interconexion/assets/img/06_Enviar_Demanda_Escrito_Inicial.png', '¿Cómo enviar una demanda o escrito inicial de manera electrónica?', 'Enviar_Demanda_Escrito_Inicial.png')"   
                                style="cursor: pointer;">
                                <i class="fas fa-image"></i> Ver
                            </a>
                        </div>
                    </div><!--BTN ROW-->
                    <div class="col-12">
                        <div class="doc-card">

                            <div class="flex-grow-1">
                                <div class="fw-semibold">¿Cómo consultar y reimprimir acuses de envío de promociones y
                                    demandas o escritos iniciales vía electrónica? </div>
                            </div>
                        <!--     <a class="btn btn-sm btn-dark rounded-pill manual-download-btn"
                                href="https://www.oaj.gob.mx/interconexion/assets/docs/pdf/7.%20C%C3%B3mo%20consultar%20y%20reimprimir%20acuses%20de%20env%C3%ADo%20de%20promociones%20y%20demandas%20o%20escritos%20iniciales%20v%C3%ADa%20electr%C3%B3nica.pdf"
                                target="_blank">Descargar</a> -->
                            <a class="btn btn-sm btn-dark rounded-pill manual-download-btn"
                                tabindex="0"
                                (click)="openImageModal('https://www.oaj.gob.mx/interconexion/assets/img/07_Consultar_Reimprimir_Acuses.png', '¿Cómo consultar y reimprimir acuses de envío de promociones y demandas o escritos iniciales vía electrónica?', 'Consultar_Reimprimir_Acuses.png')"
                                (keypress.enter)="openImageModal('https://www.oaj.gob.mx/interconexion/assets/img/07_Consultar_Reimprimir_Acuses.png', '¿Cómo consultar y reimprimir acuses de envío de promociones y demandas o escritos iniciales vía electrónica?', 'Consultar_Reimprimir_Acuses.png')"   
                                style="cursor: pointer;">
                                <i class="fas fa-image"></i> Ver
                            </a>
                        </div>
                    </div><!--BTN ROW-->
                    <div class="col-12">
                        <div class="doc-card">

                            <div class="flex-grow-1">
                                <div class="fw-semibold">¿Cómo reportar fallas técnicas e incidencias?</div>
                            </div>
                            <!-- <a class="btn btn-sm btn-dark rounded-pill manual-download-btn"
                                href="https://www.oaj.gob.mx/interconexion/assets/docs/pdf/8.%20C%C3%B3mo%20reportar%20fallas%20t%C3%A9cnicas%20e%20incidencias.pdf"
                                target="_blank">Descargar</a> -->
                            <a class="btn btn-sm btn-dark rounded-pill manual-download-btn"
                                tabindex="0"
                                (click)="openImageModal('https://www.oaj.gob.mx/interconexion/assets/img/08_Reportar_Fallas_Tecnicas.png', '¿Cómo reportar fallas técnicas e incidencias?', 'Reportar_Fallas_Tecnicas.png')"
                                (keypress.enter)="openImageModal('https://www.oaj.gob.mx/interconexion/assets/img/08_Reportar_Fallas_Tecnicas.png', '¿Cómo reportar fallas técnicas e incidencias?', 'Reportar_Fallas_Tecnicas.png')"
                                style="cursor: pointer;">
                                <i class="fas fa-image"></i> Ver
                            </a>
                        </div>
                    </div><!--BTN ROW-->
                </div>
            </div>
        </div>

        <!-- Tutoriales -->
   <!--      <div class="col-lg-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="50">
            <div class="container-fluid p-0">
                <h3 class="h5 fw-bold mb-2">Tutoriales</h3>
                <p class="small text-muted mb-4">Contenido en video y guías paso a paso.</p>

                <div class="row g-4">
                    <div class="col-12" style="max-width: 280px;">
                        <div tabindex="0" class="video-card"
                            (click)="openVideoModal('https://www.oaj.gob.mx/interconexion/assets/docs/media/Acceso_plataforma_interconexion_autoridades.mp4', 'Acceso a la Plataforma de Interconexión')"
                            (keypress.enter)="openVideoModal('https://www.oaj.gob.mx/interconexion/assets/docs/media/Acceso_plataforma_interconexion_autoridades.mp4', 'Acceso a la Plataforma de Interconexión')"
                            style="cursor: pointer;">
                            <div class="video-thumb"><i class="far fa-play-circle fa-5x"></i></div>
                            <div class="p-3">
                                <div class="fw-semibold">Acceso a la Plataforma de Interconexión</div>
                                <div class="text-muted small">Video tutorial</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12" style="max-width: 280px;">
                        <div tabindex="1" class="video-card"
                            (click)="openVideoModal('https://www.oaj.gob.mx/interconexion/assets/docs/media/personalizacion_contrase%C3%B1a.mp4', 'Personalización de Contraseña')"
                            (keypress.enter)="openVideoModal('https://www.oaj.gob.mx/interconexion/assets/docs/media/personalizacion_contrase%C3%B1a.mp4', 'Personalización de Contraseña')"
                            style="cursor: pointer;">
                            <div class="video-thumb"><i class="far fa-play-circle fa-5x"></i></div>
                            <div class="p-3">
                                <div class="fw-semibold">Personalización de Contraseña</div>
                                <div class="text-muted small">Video tutorial</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

             <!-- Guías Interactivas -->
        <div class="col-lg-6 aos-init aos-animate" data-aos="fade-up">
            <div class="container-fluid p-0">
                <h3 class="h5 fw-bold mb-2">Guías Interactivas</h3>
                <p class="small text-muted mb-4">Explora las guías interactivas que te acompañan paso a paso en el uso de la Plataforma de Interconexión</p>

                <div class="row g-4">
                    <div class="col-12">
                        <div class="doc-card">

                            <div class="flex-grow-1">
                                <div class="fw-semibold">Guía interactiva - Plataforma de interconexion con autoridades</div>
                            </div>
                            <a class="btn btn-sm btn-dark rounded-pill manual-download-btn"
                                tabindex="0"
                                (click)="openInteractiveGuideModal('https://www.oaj.gob.mx/interconexion/assets/guias/guia_completa_interconexión.html', 'Guía interactiva - Plataforma de interconexion con autoridades')"
                                (keypress.enter)="openInteractiveGuideModal('https://www.oaj.gob.mx/interconexion/assets/guias/guia_completa_interconexión.html', 'Guía interactiva - Plataforma de interconexion con autoridades')"
                                style="cursor: pointer;">
                                <i class="fas fa-book-open"></i> Ver
                            </a>
                        </div>
                    </div><!--BTN ROW-->
                    <div class="col-12">
                        <div class="doc-card">

                            <div class="flex-grow-1">
                                <div class="fw-semibold">Ingreso a la Plataforma</div>
                            </div>
                            <a class="btn btn-sm btn-dark rounded-pill manual-download-btn"
                                tabindex="0"
                                (click)="openInteractiveGuideModal('https://www.oaj.gob.mx/interconexion/assets/guias/01_ingreso_plataforma.html', 'Ingreso a la Plataforma')"
                                (keypress.enter)="openInteractiveGuideModal('https://www.oaj.gob.mx/interconexion/assets/guias/01_ingreso_plataforma.html', 'Ingreso a la Plataforma')"
                                style="cursor: pointer;">
                                <i class="fas fa-book-open"></i> Ver
                            </a>
                        </div>
                    </div><!--BTN ROW-->
                    <div class="col-12">
                        <div class="doc-card">

                            <div class="flex-grow-1">
                                <div class="fw-semibold">Personalizar Contraseña</div>
                            </div>
                            <a class="btn btn-sm btn-dark rounded-pill manual-download-btn"
                                tabindex="0"
                                (click)="openInteractiveGuideModal('https://www.oaj.gob.mx/interconexion/assets/guias/02_contrase%C3%B1a.html', 'Personalizar Contraseña')"
                                (keypress.enter)="openInteractiveGuideModal('https://www.oaj.gob.mx/interconexion/assets/guias/02_contrase%C3%B1a.html', 'Personalizar Contraseña')"
                                style="cursor: pointer;">
                                <i class="fas fa-book-open"></i> Ver
                            </a>
                        </div>
                    </div><!--BTN ROW-->
                    <div class="col-12">
                        <div class="doc-card">

                            <div class="flex-grow-1">
                                <div class="fw-semibold">Notificaciones a través de la Plataforma</div>
                            </div>
                            <a class="btn btn-sm btn-dark rounded-pill manual-download-btn"
                                tabindex="0"
                                (click)="openInteractiveGuideModal('https://www.oaj.gob.mx/interconexion/assets/guias/03_notificaci%C3%B3n.html', 'Notificaciones a través de la Plataforma')"
                                (keypress.enter)="openInteractiveGuideModal('https://www.oaj.gob.mx/interconexion/assets/guias/03_notificaci%C3%B3n.html', 'Notificaciones a través de la Plataforma')"
                                style="cursor: pointer;">
                                <i class="fas fa-book-open"></i> Ver
                            </a>
                        </div>
                    </div><!--BTN ROW-->
                    <div class="col-12">
                        <div class="doc-card">

                            <div class="flex-grow-1">
                                <div class="fw-semibold">Consulta de determinaciones y notificaciones</div>
                            </div>
                            <a class="btn btn-sm btn-dark rounded-pill manual-download-btn"
                                tabindex="0"
                                (click)="openInteractiveGuideModal('https://www.oaj.gob.mx/interconexion/assets/guias/04_archivos_constancias.html', 'Consulta de determinaciones y notificaciones')"
                                (keypress.enter)="openInteractiveGuideModal('https://www.oaj.gob.mx/interconexion/assets/guias/04_archivos_constancias.html', 'Consulta de determinaciones y notificaciones')"
                                style="cursor: pointer;">
                                <i class="fas fa-book-open"></i> Ver
                            </a>
                        </div>
                    </div><!--BTN ROW-->
                    <div class="col-12">
                        <div class="doc-card">

                            <div class="flex-grow-1">
                                <div class="fw-semibold">Consulta de expediente electrónico</div>
                            </div>
                            <a class="btn btn-sm btn-dark rounded-pill manual-download-btn"
                                tabindex="0"
                                (click)="openInteractiveGuideModal('https://www.oaj.gob.mx/interconexion/assets/guias/05_expediente_electr%C3%B3nico.html', 'Consulta de expediente electrónico')"
                                (keypress.enter)="openInteractiveGuideModal('https://www.oaj.gob.mx/interconexion/assets/guias/05_expediente_electr%C3%B3nico.html', 'Consulta de expediente electrónico')"
                                style="cursor: pointer;">
                                <i class="fas fa-book-open"></i> Ver
                            </a>
                        </div>
                    </div><!--BTN ROW-->
                    <div class="col-12">
                        <div class="doc-card">

                            <div class="flex-grow-1">
                                <div class="fw-semibold">Envío de promociones</div>
                            </div>
                            <a class="btn btn-sm btn-dark rounded-pill manual-download-btn"
                                tabindex="0"
                                (click)="openInteractiveGuideModal('https://www.oaj.gob.mx/interconexion/assets/guias/06_promocion_electr%C3%B3nica.html', 'Envío de promociones')"
                                (keypress.enter)="openInteractiveGuideModal('https://www.oaj.gob.mx/interconexion/assets/guias/06_promocion_electr%C3%B3nica.html', 'Envío de promociones')"
                                style="cursor: pointer;">
                                <i class="fas fa-book-open"></i> Ver
                            </a>
                        </div>
                    </div><!--BTN ROW-->
                    <div class="col-12">
                        <div class="doc-card">

                            <div class="flex-grow-1">
                                <div class="fw-semibold">Envío de demandas o escritos iniciales</div>
                            </div>
                            <a class="btn btn-sm btn-dark rounded-pill manual-download-btn"
                                tabindex="0"
                                (click)="openInteractiveGuideModal('https://www.oaj.gob.mx/interconexion/assets/guias/07_demanda_electr%C3%B3nica.html', 'Envío de demandas o escritos iniciales')"
                                (keypress.enter)="openInteractiveGuideModal('https://www.oaj.gob.mx/interconexion/assets/guias/07_demanda_electr%C3%B3nica.html', 'Envío de demandas o escritos iniciales')"
                                style="cursor: pointer;">
                                <i class="fas fa-book-open"></i> Ver
                            </a>
                        </div>
                    </div><!--BTN ROW-->
                    <div class="col-12">
                        <div class="doc-card">

                            <div class="flex-grow-1">
                                <div class="fw-semibold">Consulta de acuses de envío</div>
                            </div>
                            <a class="btn btn-sm btn-dark rounded-pill manual-download-btn"
                                tabindex="0"
                                (click)="openInteractiveGuideModal('https://www.oaj.gob.mx/interconexion/assets/guias/08_reimpresi%C3%B3n_acuses.html', 'Consulta de acuses de envío')"
                                (keypress.enter)="openInteractiveGuideModal('https://www.oaj.gob.mx/interconexion/assets/guias/08_reimpresi%C3%B3n_acuses.html', 'Consulta de acuses de envío')"
                                style="cursor: pointer;">
                                <i class="fas fa-book-open"></i> Ver
                            </a>
                        </div>
                    </div><!--BTN ROW-->
                    <div class="col-12">
                        <div class="doc-card">

                            <div class="flex-grow-1">
                                <div class="fw-semibold">Reporte de fallas técnicas e incidencias</div>
                            </div>
                            <a class="btn btn-sm btn-dark rounded-pill manual-download-btn"
                                tabindex="0"
                                (click)="openInteractiveGuideModal('https://www.oaj.gob.mx/interconexion/assets/guias/09_reporte_incidencias.html', 'Reporte de fallas técnicas e incidencias')"
                                (keypress.enter)="openInteractiveGuideModal('https://www.oaj.gob.mx/interconexion/assets/guias/09_reporte_incidencias.html', 'Reporte de fallas técnicas e incidencias')"
                                style="cursor: pointer;">
                                <i class="fas fa-book-open"></i> Ver
                            </a>
                        </div>
                    </div><!--BTN ROW-->
                </div>
            </div>
        </div>

    </div>
</div>